<template>
  <div>
    <input
      ref="input"
      type="file"
      class="d-none"
      accept="video/*"
      @change="enviarArquivo"

    >
    <div id="tour-step-upload-btn">
      <el-button
          size="small"
          class="btnpersonalizado"
          type="danger"
          data-v-step="1"
          @click=" openFileDialog($event);idfolderAtual();"
      >
        <feather-icon
            icon="UploadCloudIcon"
            stroke="white"
        />
        Upload
      </el-button>
    </div>

  </div>

</template>

<script>
import axios from 'axios'
import { mapActions, mapState } from 'vuex'
import { GetFrameVideoUrl } from '@/services/getFrameVideoUrl'
import { BButton, BCardText, BSpinner } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { UploadVideoService } from '@/services/uploadVideo'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'Upload',
  components: {
    BButton,
    BCardText,
    BSpinner,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
  },

  data() {
    return {
      statusConversion: '',
      loading: false,
      loadingts: 20000,
      caminhoPasta: '',
      VUE_APP_HOST_API_AWS_S3: process.env.VUE_APP_HOST_API_AWS_S3,
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND,
      userData: JSON.parse(localStorage.getItem('userData')),
      folderData: JSON.parse(localStorage.getItem('folderData')),
      folderATUAL: {},
      form: {
        files: '',
      },

      file: '',
      notification: null,
      notificationStatus: null,
      uploadPercentage: 0,
      vsl: {
        vsl_name: 'De um nome ao video',
        vsl_description: 'Sem Descrição',
        vsl_tag: 'Sem tag',
        id_user: '5',
        id_folder: '0',

      },
      estilo: {
        id_vsl: '45',
        controls_bt_big_player: '1',
        controls_bt_small_player: '1',
        controls_progress_bar: '1',
        controls_video_time: '1',
        controls_video_vol: '1',
        controls_bt_screem: '1',
        controls_avan_10s: '1',
        controls_retro_10s: '1',
        controls_back_color: '#ff0000',
        controls_main_color: '#ff0000',
      },
      Autoplay: {
        autoplayer_text_color: '#f5f5f5',
        autoplayer_back_color: '#ad1414',
        autoplayer_top_text: 'Seu vídeo já começou',
        autoplayer_button_text: 'Clique para ouvir',
      },
      ProgressoInt: {
        bar_hight: 10,
        bar_cor: '#de1717',
      },
      Viewer: {
        viewer_message: 'Você já começou a assistir esse vídeo, o que deseja fazer? ',
        viewer_bt_restart: 'Recomeçar',
        viewer_bt_continue: 'Continuar assistindo',
        viewer_back_color: '#f60909',
        viewer_color_text: '#f1f2f2',
        id_vsl: 182,
      },
      thumb: {
        tumb_start: '',
        tumb_pause: '',
        tumb_end: '',
        tumb_ativo: 0,
        tumb_key_name: '',
      },
      vslTempoVideoSemFormat: '',
      errorMessage: null,
      vslTempoVideo: '',
      UrlVideos: '',
      Hashfolder: '',
      NameVideos: '',
      key_name: '',
      IdVsl: '',
      frameCurrentVsl: {},
    }
  },
  computed: {
    ...mapState('Folders', ['folderAtual']),
  },

  mounted() {
    this.listarFolders()
  },
  methods: {
    ...mapActions('Videos', ['listarVideos']),
    ...mapActions('Folders', ['listarFolders']),

    open() {
      this.notification = this.$notify({
        title: 'Arquivo(s)',
        dangerouslyUseHTMLString: true,
        message: `<div class="container">
 <strong>Fazendo upload <i>${this.uploadPercentage}%</i> </strong>
  <div class="progress">
    <div class="progress-bar" style="width:${this.uploadPercentage}%">${this.uploadPercentage}%</div>
  </div>
</div>`,
        position: 'bottom-right',
        duration: 0,
      })
    },
    close() {
      this.notification.close()
      this.notification = null
    },
    closeStatusConversao() {
      this.notificationStatus.close()
      this.notificationStatus = null
    },

    openFileDialog() {
      this.$refs.input.value = null
      this.$refs.input.click()
    },

    clearFolder() {
      this.$store.commit('Folders/setfolderAtual', {
        id: 0,
        folder_name: null,
        folder_backet_adress: null,
        id_main: null,
        id_user: null,
        folder_date: null,
        folder_key_name: null,
      })
    },
    async idfolderAtual() {
      this.folderATUAL = JSON.parse(localStorage.getItem('folderATUAL'))
    },

    async enviarArquivo(e) {
      this.loading = true

      if (this.folderATUAL === 0) {
        this.caminhoPasta = `${this.userData.user_file_key}UploadFolderVideos/`
      } else {
        this.caminhoPasta = this.folderATUAL.folder_key_name
        console.log('loadin', this.uploadPercentage)
      }
      const formData = new FormData()

      formData.append('video', e.target.files[0])

      formData.append('caminho', `${this.caminhoPasta}`)
      this.open()
      await axios.post(`${this.VUE_APP_HOST_API_AWS_S3}/uploadVideos`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: function (progressEvent) {
            const Big = require('big.js') // importação da biblioteca
            const loaded = new Big(progressEvent.loaded)
            const total = new Big(progressEvent.total)
            this.uploadPercentage = parseInt(loaded.div(total).times(100))
          }.bind(this),

        })

        .then(async response => {
          this.vslTempoVideo = response.data.data.durationFormatted
          this.vslTempoVideoSemFormat = response.data.data.duration
          this.UrlVideos = response.data.data.fileUrl
          this.UrlVideosM3U8 = response.data.data.fileUrlm3u8
          this.NameVideos = response.data.data.fileNameOrigin
          this.key_name = response.data.data.caminhoFolder
          const paramsMidiaConvert = {
            key_vls: response.data.data.key_filename,
            key_folder: response.data.data.caminhoFolder,
            name_vsl: response.data.data.fileNameOrigin,

          }
          this.MidiaConvert(paramsMidiaConvert)

          if (response.data.data.status === 201) {
            this.frameCurrentVsl = {
              video_url: this.UrlVideos,
              caminho: response.data.data.caminhoFolder,
            }
            await fetch(`${this.VUE_APP_HOST_API_BACKEND}/vsl`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: `{"vsl_name":"${this.NameVideos}",
                "vsl_description":"${this.vsl.vsl_description}",
                "vsl_tag":"${this.vsl.vsl_tag}",
                "id_user":"${this.userData.id}",
                "id_folder":"${this.folderATUAL.id}",
                "vsl_bucket_address":"${this.UrlVideos}",
                "vsl_key_name":"${this.key_name}",
                 "vsl_frame":"${this.UrlVideos}",
                 "vsl_tempoVideo":"${this.vslTempoVideo}",
                 "vsl_bucket_address_m3u8":"${this.UrlVideosM3U8}"
                  }`,
            })
              .finally(() => {
                this.loading = false
                this.loadingts = 0
              })
              .then(response => response.json())
              .then(async response => {
                this.IdVsl = response.Id
                this.frameCurrentVsl.vsl_id = response.Id
                this.listarVideos()
                this.$message({
                  type: 'success',
                  message: 'Upload concluido com sucesso',
                })

                if (response.status === 201) {
                  fetch(`${this.VUE_APP_HOST_API_BACKEND}/control`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: `{"id_vsl":"${this.IdVsl
                    }","controls_bt_big_player":"${this.estilo.controls_bt_big_player
                    }","controls_bt_small_player":"${this.estilo.controls_bt_small_player
                    }","controls_progress_bar":"${this.estilo.controls_progress_bar
                    }","controls_video_time":"${this.estilo.controls_video_time
                    }","controls_video_vol":"${this.estilo.controls_video_vol
                    }","controls_bt_screem":"${this.estilo.controls_bt_screem
                    }","controls_retro_10s":"${this.estilo.controls_retro_10s
                    }","controls_avan_10s":"${this.estilo.controls_avan_10s
                    }","controls_back_color":"${this.estilo.controls_back_color
                    }","controls_main_color":"${this.estilo.controls_main_color
                    }"}`,
                  })
                  fetch(`${this.VUE_APP_HOST_API_BACKEND}/atuvsl`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: `{"id_vsl":"${this.IdVsl
                    }","ptime":"${this.vslTempoVideoSemFormat}","pvisitorId":"0"}`,
                  })
                  fetch(`${this.VUE_APP_HOST_API_BACKEND}/autoplayer`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: `{"id_vsl":"${this.IdVsl
                    }","autoplayer_text_color":"${this.Autoplay.autoplayer_text_color
                    }","autoplayer_back_color":"${this.Autoplay.autoplayer_back_color
                    }","autoplayer_top_text":"${this.Autoplay.autoplayer_top_text
                    }","autoplayer_button_text":"${this.Autoplay.autoplayer_button_text
                    }"}`,
                  })
                  fetch(`${this.VUE_APP_HOST_API_BACKEND}/bar`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: `{"id_vsl":"${this.IdVsl
                    }","bar_hight":"${this.ProgressoInt.bar_hight
                    }","bar_cor":"${this.ProgressoInt.bar_cor
                    }"}`,
                  })
                  fetch(`${this.VUE_APP_HOST_API_BACKEND}/viewer`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: `{"id_vsl":"${this.IdVsl
                    }","viewer_message":"${this.Viewer.viewer_message
                    }","viewer_bt_restart":"${this.Viewer.viewer_bt_restart
                    }","viewer_bt_continue":"${this.Viewer.viewer_bt_continue
                    }","viewer_back_color":"${this.Viewer.viewer_back_color
                    }","viewer_color_text":"${this.Viewer.viewer_color_text
                    }"}`,
                  })
                  fetch(`${this.VUE_APP_HOST_API_BACKEND}/tumb`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: `{"id_vsl":"${this.IdVsl
                    }","tumb_start":"${this.thumb.tumb_start
                    }","tumb_pausa":"${this.thumb.tumb_pause
                    }","tumb_end":"${this.thumb.tumb_end
                    }","tumb_ativo":"${this.thumb.tumb_ativo
                    }","tumb_key_name_end":"${this.thumb.tumb_key_name

                    }"}`,
                  })

                  fetch(`${this.VUE_APP_HOST_API_BACKEND}/analytic`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: `{"id_vsl":"${this.IdVsl}"}`,
                  })
                    .then(response => {
                      console.log(response, 'AutoPLay')
                    })
                }
                this.close()
                this.clearFolder()
              })

              .catch(err => console.error(err))
          }
        })
        .catch(() => {
          console.log('FAILURE!!')
        })
      await new GetFrameVideoUrl().execute(this.frameCurrentVsl)
        .then(async resp => {
          console.log('resp', resp)

          await this.$api.put('/updateFrame', {
            id_vsl: this.frameCurrentVsl.vsl_id,
            vsl_frame: resp.file_url_frame,
          })
            .finally(() => {
              this.listarVideos()
            })
        })
    },
    async MidiaConvert(params) {
      const uploadVideoService = new UploadVideoService()
      await uploadVideoService.mediaConvert(params)
        .then(response => {
          this.MonitorarConversao(response.JobId)
        })
        .catch(err => console.error(err))
    },

    async MonitorarConversao(jobId) {
      let status = ''
      const menssageCard = `<div class="container">
    <strong>Processando <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
    <span class="visually-hidden">Loading...</span> </strong>
  </div>`
      const uploadVideoService = new UploadVideoService()

      this.notificationStatus = this.$notify({
        title: 'Em instantes o Embed estará disponível',
        dangerouslyUseHTMLString: true,
        message: menssageCard,
        position: 'bottom-right',
        duration: 0,
      })

      while (status !== 'COMPLETE' && status !== 'ERROR') {
        await new Promise(resolve => setTimeout(resolve, 5000)) // espera 5 segundos

        const response = await uploadVideoService.monitorarConversao(jobId)
        status = response.status

        console.log(`Status da job ${status}`)
      }
      if (status === 'COMPLETE') {
        this.$notify({
          title: 'Sucesso',
          message: 'Configurações geradas com sucesso',
          type: 'success',
          position: 'bottom-right',
          duration: 5000,
        })
      } else if (status === 'ERROR') {
        this.$notify({
          title: 'Erro',
          message: 'Ocorreu um erro durante a criação das configurações',
          type: 'error',
          position: 'bottom-right',
          duration: 5000,
        })
      }
      setTimeout(() => {
        this.closeStatusConversao()
      }, 3000)
    },
  },
  watch: {
    uploadPercentage(newValue) {
      this.notification.message = `<div class="container">
 <strong>Fazendo upload <i>${newValue}%</i> </strong>
  <div class="progress">
    <div class="progress-bar" style="width:${newValue}%">${newValue}%</div>
  </div>
</div>`
    },
  },
}
</script>
